import { CheckCircle2, ChevronRight, FileText, Receipt } from 'lucide-react';
import { BookingDetails } from '../../types/booking-details.types';

export function DrawerFooter({
  booking,
  onAction,
  onClose,
}: {
  booking: BookingDetails;
  onAction: (
    action: 'accept' | 'reject' | 'quote' | 'download' | 'pro-forma' | 'confirm-payment' | 'generate-invoice',
    id: string,
  ) => void;
  onClose: () => void;
}) {
  const isQuoteWorkflow =
    booking.status === 'QUOTE_REQUESTED' ||
    booking.status === 'QUOTED' ||
    booking.status === 'URGENT' ||
    booking.status === 'OVERDUE';

  // ✅ FIX: Le bouton "Générer Facture" ne doit apparaître que si le montant TOTAL est payé
  // URGENT/OVERDUE = seulement les frais d'urgence sont payés, pas le montant total
  // On ne génère une facture complète que si status = PAID
  const canGenerateInvoice = booking.status === 'PAID' || booking.financials.paymentStatus === 'PAID';

  return (
    <div className="border-t border-slate-200 bg-white p-4 px-6 shrink-0 flex items-center justify-center gap-3 rounded-b-2xl">
      <div className="flex items-center gap-3">
        {isQuoteWorkflow && (
          <button
            onClick={() => onAction('pro-forma', booking.id)}
            className="flex items-center gap-2 px-4 py-2.5 text-sm font-semibold text-[#00303c] bg-[#dfc32f] hover:bg-[#dfc32f]/90 rounded-lg transition-colors shadow-sm"
          >
            <FileText className="w-4 h-4" />
            Voir Devis
          </button>
        )}

        {canGenerateInvoice && (
          <button
            onClick={() => onAction('generate-invoice', booking.id)}
            className="flex items-center gap-2 px-4 py-2.5 text-sm font-semibold text-white bg-[#a4006c] hover:bg-[#a4006c]/90 rounded-lg transition-colors shadow-sm"
            title="Générer une facture"
          >
            <Receipt className="w-4 h-4" />
            Générer Facture
          </button>
        )}

        {booking.status === 'PENDING' && (
          <button
            onClick={() => onAction('accept', booking.id)}
            className="px-6 py-2.5 text-sm font-semibold text-white bg-[#00758d] hover:bg-[#00758d]/90 rounded-lg transition-colors shadow-sm"
          >
            Accepter
          </button>
        )}

        {booking.status === 'QUOTE_REQUESTED' && (
          <button
            onClick={() => onAction('quote', booking.id)}
            className="px-6 py-2.5 text-sm font-semibold text-white bg-[#00758d] hover:bg-[#00758d]/90 rounded-lg transition-colors flex items-center gap-2 shadow-sm"
          >
            Émettre un devis <ChevronRight className="w-4 h-4" />
          </button>
        )}

        {booking.status === 'PAYMENT_PENDING' && (
          <button
            onClick={() => onAction('confirm-payment', booking.id)}
            className="px-6 py-2.5 text-sm font-semibold text-white bg-[#00758d] hover:bg-[#00758d]/90 rounded-lg transition-colors flex items-center gap-2 shadow-sm"
          >
            Confirmer le paiement <CheckCircle2 className="w-4 h-4" />
          </button>
        )}

        {(booking.status === 'CONFIRMED' || booking.status === 'PAID' || booking.status === 'CANCELLED') && (
          <button
            onClick={onClose}
            className="px-6 py-2.5 text-sm font-semibold text-white bg-[#5c4738] hover:bg-[#5c4738]/90 rounded-lg transition-colors shadow-sm"
          >
            Fermer
          </button>
        )}
      </div>
    </div>
  );
}
